import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { onboardingApi } from '../api/onboardingApi';

interface OnboardingState {
    data: object | null;
}

const initialState: OnboardingState = {
    data: null,
};

const onboardingSlice = createSlice({
    name: 'onboarding',
    initialState,
    reducers: {
        setPrefilledCurrentScreenData: (state, action: PayloadAction<object>) => {
            state.data = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addMatcher(onboardingApi.endpoints.getOnboardingData.matchFulfilled, (state, { payload }: any) => {
                state.data = payload.data;
            });
    },
});

export const { setPrefilledCurrentScreenData } = onboardingSlice.actions;

export default onboardingSlice.reducer;
